import React, { useState } from "react";
import { Badge, Box, Button, Card, CardContent, IconButton, Menu, MenuItem } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import styles from "./Notification.module.scss";
import {
	useGetNotificationsQuery,
	useReadNotificationMutation,
} from "../../services/notifications";

const Notification = () => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const { data: notificationRes, refetch } = useGetNotificationsQuery();
	const [readNotification] = useReadNotificationMutation();
	const menuItemOpen = Boolean(anchorEl);

	const handleClick = async (event) => {
		try {
			setAnchorEl(event.currentTarget);

			const notifcationPromises = [];

			if (notificationRes.notifications.length) {
				for (let index = 0; index < notificationRes.notifications.length; index++) {
					const notification = notificationRes.notifications[index];

					if (!notification?.isView) {
						notifcationPromises.push(
							readNotification({
								...notification,
								id: notification._id,
								isView: true,
							})
						);
					}
				}
			}

			const results = await Promise.all(notifcationPromises);

			if (results.length) {
				refetch();
			}
		} catch (error) {
			console.log(error);
		}
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const unReadNotifications =
		(notificationRes?.notifications || [])?.filter(({ isView }) => !isView).length || 0;

	return (
		<div>
			<IconButton aria-label="cart" sx={{ color: "cornflowerblue" }}>
				<Badge
					badgeContent={unReadNotifications}
					color="secondary"
					onClick={handleClick}
					overlap="circular"
					anchorOrigin={{
						vertical: "top",
						horizontal: "right",
					}}
				>
					<NotificationsIcon />
				</Badge>
			</IconButton>

			<Menu
				anchorEl={anchorEl}
				id="notification-menu"
				open={menuItemOpen}
				className={styles.notificationMenu}
				onClose={handleClose}
				MenuListProps={{
					"aria-labelledby": "basic-button",
				}}
				Paper={{
					style: {
						maxHeight: 400,
					},
				}}
			>
				{notificationRes &&
					notificationRes?.notifications.map((notification) => (
						<MenuItem key={notification._id} onClick={handleClose}>
							<Card sx={{ backgroundColor: "lavendar", color: "" }}>
								<CardContent>
									<p className={styles.notificationCard}>{notification.notes}</p>
								</CardContent>
							</Card>
						</MenuItem>
					))}
				<Box
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						alignItems: "center",
						marginRight: "15px",
					}}
				>
					{notificationRes &&
						notificationRes.notifications &&
						notificationRes.notifications.length > 3 && (
							<Button onClick={handleClose}>Show More</Button>
						)}
					{!notificationRes?.notifications?.length && (
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								paddingLeft: "10px",
							}}
						>
							No notification found!
						</Box>
					)}
				</Box>
			</Menu>
		</div>
	);
};

export default Notification;
